module.exports = __webpack_public_path__ + "716ebfb061cc44c8fadeb91eda4144cd.svg";